// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "Completion Score",
            learn_more_text: "Learn More",
            info_btn_details: {
              video_url: undefined,
              question: "What is Completion Score?",
              answer: "Completion Score is calculated as the total orders completed among the last 50 orders assigned to you. \n\n                                  Eg : If Porter assigns 50 orders and if you complete 40, then completion score is 80%"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "What is completion score and why it is important ?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "How can i improve my completion score?",
                answer: "Accept and complete all orders to maintain high completion score"
              },
              {
                video_url: undefined,
                question: "What is a good completion score?",
                answer: "Highest earning Porter partners maintains a completion score of 90% or more."
              },
              {
                video_url: undefined,
                question: "Why i am not able to see my completion rate?",
                answer: "Score is calculated only for those partners who have received atleast 50 orders."
              }
            ],
            locked_score_msg: "Accept more trips to unlock the score",
            message_text: "Partners with higher completion score have higher chances of getting more orders."
          };
  } else {
    return {
            title_text: "Completion Score",
            learn_more_text: "Learn More",
            info_btn_details: {
              video_url: undefined,
              question: "What is Completion Score?",
              answer: "Completion Score is calculated as the total orders completed among the last 50 orders assigned to you. Orders pinged to you but accepted by another partner before you are not counted in your score \n\n                    Eg : If Porter assigns 50 orders and if you complete 40, then completion score is 80%"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "What is completion score and why it is important ?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "How can i improve my completion score?",
                answer: "Accept and complete all orders to maintain high completion score"
              },
              {
                video_url: undefined,
                question: "What is a good completion score?",
                answer: "Highest earning Porter partners maintains a completion score of 90% or more."
              },
              {
                video_url: undefined,
                question: "Why i am not able to see my completion rate?",
                answer: "Score is calculated only for those partners who have received atleast 50 orders."
              }
            ],
            locked_score_msg: "Accept more trips to unlock the score",
            message_text: "Partners with higher completion score have higher chances of getting more orders."
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
